import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import CoberturaNota from '../../components/CoberturaNota/CoberturaNota';
import './DesarrolloWebEcommercePage.css';

const DesarrolloWebEcommercePage = ({ darkMode, toggleDarkMode }) => {
  const beneficios = [
    {
      titulo: 'Presencia Digital Profesional',
      descripcion: 'Webs modernas, rápidas y optimizadas que representan profesionalmente tu marca y generan confianza.'
    },
    {
      titulo: 'Ventas Online 24/7',
      descripcion: 'E-commerce que funciona las 24 horas, permitiendo ventas automáticas sin necesidad de personal.'
    },
    {
      titulo: 'Diseño Responsive',
      descripcion: 'Webs que se adaptan perfectamente a móviles, tablets y escritorio, maximizando conversiones.'
    },
    {
      titulo: 'Integración con tu Negocio',
      descripcion: 'Webs conectadas con tu ERP, inventario, facturación y sistemas, no solo escaparates estáticos.'
    },
    {
      titulo: 'Orientadas a conversión',
      descripcion: 'Estructura clara, formularios y llamadas a la acción pensados para generar leads y pedidos, no solo visitas.'
    },
    {
      titulo: 'Rendimiento Optimizado',
      descripcion: 'Webs rápidas que mejoran la experiencia del usuario y aumentan las conversiones.'
    }
  ];

  const tiposDesarrollo = [
    {
      titulo: 'Desarrollo Web Corporativo',
      descripcion: 'Webs corporativas modernas y rápidas que representan profesionalmente tu marca y conectan con tus sistemas.',
      caracteristicas: [
        'Diseño responsive y moderno',
        'Buenas prácticas técnicas de base',
        'Integración con sistemas',
        'Panel de administración',
        'Formularios y contactos',
        'Blog y contenidos'
      ]
    },
    {
      titulo: 'E-commerce y Tiendas Online',
      descripcion: 'Tiendas online completas con carrito, pasarelas de pago, gestión de pedidos e integración con inventario.',
      caracteristicas: [
        'Catálogo de productos',
        'Carrito y checkout',
        'Pasarelas de pago',
        'Gestión de pedidos',
        'Integración con inventario',
        'Panel de administración'
      ]
    },
    {
      titulo: 'Aplicaciones Web',
      descripcion: 'Aplicaciones web personalizadas para procesos específicos: reservas, pedidos, gestión de clientes, etc.',
      caracteristicas: [
        'Funcionalidades personalizadas',
        'Interfaz intuitiva',
        'Acceso multiusuario',
        'Integración con sistemas',
        'Responsive y rápida',
        'Seguridad avanzada'
      ]
    },
    {
      titulo: 'Landing Pages y Micrositios',
      descripcion: 'Páginas de aterrizaje optimizadas para conversión y micrositios para campañas específicas.',
      caracteristicas: [
        'Optimización de conversión',
        'Diseño atractivo',
        'Formularios optimizados',
        'Integración con CRM',
        'Analytics integrado',
        'A/B testing'
      ]
    }
  ];

  const tecnologias = [
    {
      categoria: 'Frontend',
      tecnologias: ['React', 'Next.js', 'Vue.js', 'TypeScript', 'Tailwind CSS']
    },
    {
      categoria: 'E-commerce',
      tecnologias: ['WooCommerce', 'Shopify', 'PrestaShop', 'Desarrollo personalizado']
    },
    {
      categoria: 'Backend',
      tecnologias: ['Node.js', 'PHP', 'Python', 'Laravel']
    },
    {
      categoria: 'CMS',
      tecnologias: ['WordPress', 'Headless CMS', 'Strapi', 'Contentful']
    },
    {
      categoria: 'Cloud y Hosting',
      tecnologias: ['Azure', 'AWS', 'Vercel', 'Netlify', 'Docker']
    }
  ];

  const proceso = [
    {
      paso: '1',
      titulo: 'Análisis y Planificación',
      descripcion: 'Analizamos tus necesidades, objetivos y público objetivo para diseñar la mejor solución web.'
    },
    {
      paso: '2',
      titulo: 'Diseño y Prototipado',
      descripcion: 'Creamos el diseño visual y prototipos interactivos para validar antes del desarrollo.'
    },
    {
      paso: '3',
      titulo: 'Desarrollo',
      descripcion: 'Desarrollamos la web o e-commerce con las mejores tecnologías, optimizada y responsive.'
    },
    {
      paso: '4',
      titulo: 'Integración y Pruebas',
      descripcion: 'Integramos con tus sistemas existentes y realizamos pruebas exhaustivas de funcionalidad y rendimiento.'
    },
    {
      paso: '5',
      titulo: 'Lanzamiento y Evolución',
      descripcion: 'Lanzamos la web, configuramos analytics y la evolucionamos según el uso real y las necesidades del negocio.'
    }
  ];

  const serviciosAdicionales = [
    {
      titulo: 'Mantenimiento y Evolución',
      descripcion: 'Actualizaciones, backups, seguridad y mejoras continuas para webs ya en producción.'
    },
    {
      titulo: 'Integración con Sistemas',
      descripcion: 'Conectamos tu web con ERP, inventario, contabilidad y otros sistemas para automatizar procesos.'
    },
    {
      titulo: 'Optimización de Conversión',
      descripcion: 'Análisis y mejoras para aumentar conversiones: formularios, checkout, llamadas a la acción.'
    }
  ];

  const sectores = [
    {
      titulo: 'Retail y Comercio',
      descripcion: 'E-commerce para tiendas físicas y online, catálogos digitales y venta multicanal.'
    },
    {
      titulo: 'Servicios Profesionales',
      descripcion: 'Webs corporativas para despachos, consultorías y empresas de servicios con formularios y citas.'
    },
    {
      titulo: 'Hostelería y Turismo',
      descripcion: 'Webs con sistemas de reservas, galerías, integración con OTAs y gestión de disponibilidad.'
    },
    {
      titulo: 'Educación',
      descripcion: 'Plataformas educativas, webs de academias con gestión de cursos y alumnos.'
    },
    {
      titulo: 'Salud y Bienestar',
      descripcion: 'Webs para clínicas con sistemas de citas, historiales y cumplimiento normativo.'
    },
    {
      titulo: 'Inmobiliaria',
      descripcion: 'Webs inmobiliarias con catálogo de propiedades, búsqueda avanzada y gestión de visitas.'
    }
  ];

  return (
    <>
      <SEO 
        title="Webs y E-commerce Conectados con tu Negocio | E-ASY"
        description="Desarrollamos webs corporativas, tiendas online y aplicaciones web conectadas con ERP, inventario y sistemas de gestión. Integración y mantenimiento, no solo escaparates."
        keywords="web conectada ERP, ecommerce integrado, desarrollo web empresas, tienda online integrada, aplicaciones web, mantenimiento web, E-ASY"
        canonical="https://e-asy.es/servicios/desarrollo-web-ecommerce"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`desarrollo-web-ecommerce-page ${darkMode ? 'dark' : 'light'}`}>
        
        {/* Hero Section */}
        <section className="desarrollo-hero">
          <div className="desarrollo-hero-content">
            <div className="desarrollo-hero-text">
              <h1 className="desarrollo-hero-title">Desarrollo Web y E-commerce</h1>
              <p className="desarrollo-hero-subtitle">
                E-ASY desarrolla <strong>webs y e-commerce</strong> que no son solo escaparates, sino herramientas 
                conectadas con tu negocio. <strong>Desarrollo web corporativo</strong>, <strong>tiendas online</strong>, 
                <strong>aplicaciones web</strong> y <strong>landing pages</strong> optimizadas para conversión.
              </p>
              <p className="desarrollo-hero-subtitle">
                Webs <strong>conectadas con tu ERP</strong>, inventario y sistemas: <strong>rápidas</strong>, 
                <strong>responsive</strong> y pensadas para generar negocio. Desde <strong>Canarias</strong> para 
                empresas en toda <strong>España</strong> y proyectos <strong>internacionales</strong>.
              </p>
              <div className="desarrollo-hero-cta">
                <Link to="/contacto" className="desarrollo-hero-button primary">
                  Solicita una consultoría gratuita
                </Link>
                <Link to="/servicios" className="desarrollo-hero-button secondary">
                  Ver todos los servicios
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Qué es Section */}
        <section className="desarrollo-que-es">
          <div className="desarrollo-que-es-content">
            <div className="desarrollo-que-es-header">
              <h2 className="desarrollo-que-es-title">¿Por qué tu Empresa Necesita una Web Profesional?</h2>
              <p className="desarrollo-que-es-subtitle">
                En 2025, tener una <strong>web profesional</strong> no es opcional, es esencial. Tu web es la primera 
                impresión que tienen tus clientes potenciales y puede ser tu mejor vendedor trabajando 24/7.
              </p>
              <p className="desarrollo-que-es-subtitle">
                Pero una web no es solo un escaparate. Una <strong>web conectada con tu negocio</strong> puede sincronizar 
                inventario, procesar pedidos automáticamente, integrarse con tu ERP y generar leads cualificados. 
                Es la diferencia entre una web que solo informa y una que <strong>genera negocio</strong>.
              </p>
            </div>
          </div>
        </section>

        {/* Beneficios Section */}
        <section className="desarrollo-beneficios">
          <div className="desarrollo-beneficios-content">
            <div className="desarrollo-beneficios-header">
              <h2 className="desarrollo-beneficios-title">Beneficios de una Web Profesional</h2>
              <p className="desarrollo-beneficios-subtitle">
                Ventajas de tener una web moderna, optimizada y conectada con tu negocio
              </p>
            </div>
            <div className="desarrollo-beneficios-grid">
              {beneficios.map((beneficio, index) => (
                <div key={index} className="desarrollo-beneficio-card">
                  <h3 className="beneficio-title">{beneficio.titulo}</h3>
                  <p className="beneficio-description">{beneficio.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tipos de Desarrollo Section */}
        <section className="desarrollo-tipos">
          <div className="desarrollo-tipos-content">
            <div className="desarrollo-tipos-header">
              <h2 className="desarrollo-tipos-title">Tipos de Desarrollo Web que Ofrecemos</h2>
              <p className="desarrollo-tipos-subtitle">
                Soluciones web adaptadas a diferentes necesidades empresariales
              </p>
            </div>
            <div className="desarrollo-tipos-grid">
              {tiposDesarrollo.map((tipo, index) => (
                <div key={index} className="desarrollo-tipo-card">
                  <h3 className="tipo-title">{tipo.titulo}</h3>
                  <p className="tipo-description">{tipo.descripcion}</p>
                  <div className="tipo-caracteristicas">
                    <h4 className="caracteristicas-title">Incluye:</h4>
                    <ul className="caracteristicas-list">
                      {tipo.caracteristicas.map((caracteristica, idx) => (
                        <li key={idx} className="caracteristica-item">{caracteristica}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tecnologías Section */}
        <section className="desarrollo-tecnologias">
          <div className="desarrollo-tecnologias-content">
            <div className="desarrollo-tecnologias-header">
              <h2 className="desarrollo-tecnologias-title">Tecnologías que Utilizamos</h2>
              <p className="desarrollo-tecnologias-subtitle">
                Trabajamos con las tecnologías más modernas y robustas del mercado
              </p>
            </div>
            <div className="desarrollo-tecnologias-grid">
              {tecnologias.map((categoria, index) => (
                <div key={index} className="tecnologia-categoria-card">
                  <h3 className="categoria-title">{categoria.categoria}</h3>
                  <div className="tecnologias-tags">
                    {categoria.tecnologias.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso Section */}
        <section className="desarrollo-proceso">
          <div className="desarrollo-proceso-content">
            <div className="desarrollo-proceso-header">
              <h2 className="desarrollo-proceso-title">Nuestro Proceso de Desarrollo</h2>
              <p className="desarrollo-proceso-subtitle">
                Metodología estructurada que asegura el éxito de tu proyecto web
              </p>
            </div>
            <div className="desarrollo-proceso-timeline">
              {proceso.map((item, index) => (
                <div key={index} className="proceso-step">
                  <div className="step-number">{item.paso}</div>
                  <div className="step-content">
                    <h3 className="step-title">{item.titulo}</h3>
                    <p className="step-description">{item.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Servicios Adicionales Section */}
        <section className="desarrollo-servicios">
          <div className="desarrollo-servicios-content">
            <div className="desarrollo-servicios-header">
              <h2 className="desarrollo-servicios-title">Servicios Adicionales</h2>
              <p className="desarrollo-servicios-subtitle">
                Más allá del desarrollo, ofrecemos servicios complementarios para maximizar el éxito de tu web
              </p>
            </div>
            <div className="desarrollo-servicios-grid">
              {serviciosAdicionales.map((servicio, index) => (
                <div key={index} className="desarrollo-servicio-card">
                  <h3 className="servicio-title">{servicio.titulo}</h3>
                  <p className="servicio-description">{servicio.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sectores Section */}
        <section className="desarrollo-sectores">
          <div className="desarrollo-sectores-content">
            <div className="desarrollo-sectores-header">
              <h2 className="desarrollo-sectores-title">Desarrollo Web para Diferentes Sectores</h2>
              <p className="desarrollo-sectores-subtitle">
                Adaptamos el desarrollo web a las necesidades específicas de cada sector
              </p>
            </div>
            <div className="desarrollo-sectores-grid">
              {sectores.map((sector, index) => (
                <div key={index} className="desarrollo-sector-card">
                  <h3 className="sector-title">{sector.titulo}</h3>
                  <p className="sector-description">{sector.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="desarrollo-cta">
          <div className="desarrollo-cta-content">
            <h2 className="desarrollo-cta-title">¿Necesitas una Web o E-commerce para tu Empresa?</h2>
            <p className="desarrollo-cta-subtitle">
              Agenda una consultoría gratuita y descubre cómo podemos crear la web perfecta para tu negocio
            </p>
            <div className="desarrollo-cta-buttons">
              <Link to="/contacto" className="desarrollo-cta-button primary">
                Solicita una consultoría gratuita
              </Link>
              <Link to="/servicios" className="desarrollo-cta-button secondary">
                Ver todos los servicios
              </Link>
            </div>
          </div>
        </section>

      </div>
      <CoberturaNota />
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default DesarrolloWebEcommercePage;






